import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  BLOOM_CONFIG,
  BloomStats,
} from '../PerformanceDrawer/performanceDrawerData';
import { pxToRem } from '@geneo2-web/shared-ui';
import { ProgressBar } from '../ProgressBar';
import { LevelRow } from '../LevelRow';
interface BloomItemProps {
  data: BloomStats;
}
export const BloomProgressItem = ({ data }: { data: BloomStats[] }) => {
  const { t } = useTranslation();
  const config = BLOOM_CONFIG;

  return (
    <Box display="flex" flexDirection="column" gap={pxToRem(10)}>
      {data.map((item) => {
        const conf = config[item.level];

        return (
          <LevelRow
            key={item.level}
            label={t(`PAL_BLOOM_${String(conf.label).toUpperCase()}`)}
            correct={item.correct}
            total={item.total}
            color={conf.color}
            bgColor={conf.bg}
          />
        );
      })}
    </Box>
  );
};
